export default __webpack_public_path__ + "7a100abd7d7cef8b16bbb93d9d55c71a.png";